<style>

.modal{
	color:  rgb(99, 107, 111);
	z-index: 999;
}
.absolute-bg-black{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.6);
	z-index: 1200;
}
.modal-drawer{
	margin-top: 0.5%;
	height: 98.5%;
	margin-bottom: 1%;
	animation-duration: 0.55s;
	animation-fill-mode: both;
	animation-name: fadeInDown;
	z-index: 1202;
}

 img {
	height: 4em;
 }

 h3 {
	font-size: 19px;
 }

 .modal h4 {
	font-size: 15px;
	color: #a83660;
	text-decoration: none;
	user-select: none;
}

 .btn-success {
	color: #fff;
	background-color: #a83660;
	border-color: #be6e8c;
}

 .btn-danger {
	color: #fff;
	background-color: #a83660;
	border-color: #be6e8c;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateX(200%);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.modal-drawer .modal-lg {
	min-width: 30em;
	max-width: 0em;
}
.rounded-image {
	width: 3.5em;
	height: 3.5em;
	border-radius: 12%;
	object-fit: cover;
}
</style>

<template>
  <div>
<!--		<div class="absolute-bg-black" v-if="is_show_modal_cart "></div>-->
		<div :id="id" class="modal modal-drawer fade-right has-shown"  @click.self="closeModal">
			<div class="modal-dialog modal-drawer-right" :class="[size != undefined ? size : 'modal-lg']" role="document">
				<div class="modal-content shadow-lg">
					<div v-show="!isMobile" @click="closeModal()" class="close-drawer-modal bg-danger pointer">
						Закрыть
					</div>
					<div class="modal-header">
						<div class=" row centerall">
							<div class="col-3 col-xs-3">
								<img src="/image/trash.svg" style="text-align: right"  @click="closeModal()">
							</div>
							<div class="col-6 col-xs-6"><br><h3>ВАША КОРЗИНА</h3></div>
							<div class="col-3 col-xs-3">
								<img src="/image/logo.svg" >
							</div>
						</div>
					</div>
					<div class="modal-body overflow-y-auto">
							<hr>
							<div id="TrashTable" class="row"  v-if="data && data.length>0"  v-for="(item,key) in data">
								<div class="col-2 col-xs-2">
									<img :src="item.photo" class="rounded-image">
								</div>
								<div class="col-4">
									{{item.name}}<br>
									<span style="color:#a83660"> {{item.priceone}}</span>р.\{{item.weight}}г.
								</div>
								<div class="col-3">
									<input type="number" class="form-control" v-model="item.number" @change="updatecount(key,item.number )" min="1" max="99">
								</div>
								<div class="col-2">{{item.price}}</div>
								<div class="col-1" style="text-align: end">
									<button title="" type="button" class="delete-pos btn-sm btn " @click="deletepos(key)" >
										<i class="fa fa-trash red"></i></button>
								</div>
								<br>
							</div>
							<br>	<br>
						<div class="container ">

						<h3 style="text-align: end;">Итого: <span style="color:#a83660"> {{price}}</span> руб.</h3>
							<br>
							<br>
							<div class="centerall row">
							<hr>
							<H3>ЗАКАЗ</H3>
							<br>
							<br>
							<H3 style="color: #a63661">ВНИМАНИЕ</H3>
								<h3 v-show="message!=''">{{message}}</h3>
								<br> Доставка осуществляется от 1000р
							<br> Заказ действителен только после того как оператор перезвонит Вам
							<hr>

							<div class="form-group">
								<input  v-model="form.name" class="form-control" type="text" name="name" placeholder="Имя"   maxlength="40" required autofocus>
							</div>
							<div class="form-group">
								<input type="text"  v-model="form.phone" class="form-control" id="phone" name="phone"  placeholder="Телефон" maxlength="14"  required>
<!--								<the-mask :mask="['#(###) ###-####', '#(###) ###-####']" id="phone" name="phone" placeholder="Номер для связи" v-model="form.phone" class="form-control" />-->
							</div>
							<div class="form-group">
								<textarea name="comment" class='form-control' id='adress' v-model="form.adress" cols="50"
													rows="3" placeholder='Адрес'></textarea>
							</div>
								<div class="form-group">
 								<textarea name="comment" class='form-control' id='comment' v-model="form.comment" cols="50"
								 rows="8" placeholder='Примечания к заказу'></textarea>
								</div>
								<hr>

									<!--									<h2>{{price_view}} р</h2>-->
									<div class="buy"  @click="addZakaz()">
										<img src="/image/button.svg" >
									</div>
								</div>

						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
  name: "rightCartWidget",
  props: [
    'id', 'title', 'size'
  ],
  data: function(){
    return {
      isMobile: window.innerWidth < 767,
			is_show_modal_cart: false,
			data: [],
			message: '',
			price: 0,
			weight: 0,
      is_fon: true,
			form: new Form({
				adress : '',
				name: '',
				phone: '',
				comment: '',
			}),
			urls: {
				create: "/api/client",
				message: "/api/client/mess",
			}
    }
  },
  methods: {
		validatePhoneNumber() {
			// Регулярное выражение для валидации номера телефона
			//const phoneRegex =/^(?:\+7|7|8)?[0-9]{11}$/;
			const phoneRegex =/^([0-9\s\-\+\(\)]*)$/;

			if (!phoneRegex.test(this.phone)) {
				this.toast('Неверный формат номера телефона')
				return false;
			} else {
				return true;
			}
		},
		toast(mes){
			Toast.fire({
				timer: 5000,
				icon: 'error',
				title: mes
			});
		},
		addZakaz() {
			if (this.form.adress==''){
				this.toast('Поле адрес не заполнено')
				return;
			}
			if (this.form.phone==''){
				this.toast('Поле телефон не заполнено')
				return;
			}
			// if (this.validatePhoneNumber()===false) return;

			var json = this.getCookie('data');
			var	cart = JSON.parse(json);

			if (cart===null || cart.length===0){
				this.toast('Ваша корзина пуста')
				return;
			}
			axios.post(this.urls.create, {
									cart: cart,
									adress: this.form.adress,
									name: this.form.name,
									phone: this.form.phone,
									price: this.price,
									weight: this.weight,
									comment: this.form.comment
								})
							.then((response) => {
								var array=[];
								this.setCookie('data',JSON.stringify(array));
								this.setCookie('count', 0);
								this.$router.push({path: '/userzakaz/'+response.data.data.id});
							})
							.catch((errors) => {
								this.$Progress.fail();
								//  console.log(errors);
								this.validateErrors(errors);
							});
		},
		priceFunction(){
			this.price= this.data.reduce((sum, item) => sum + item.price, 0);
			this.weight= this.data.reduce((sum, item) => sum + item.weightall, 0);
		},
		updatecount(key,number){
			for (var i = 0; this.data.length; i++) {
				if (key == i) {
					this.data[key].number=parseInt(number);
					this.data[key].price=parseInt(number) * parseInt(this.data[key].priceone);
					this.data[key].weightall=parseInt(number) * parseInt(this.data[key].weight);
					var	array = JSON.stringify(this.data);
					this.setCookie('data',array);
					this.priceFunction();
					return;
				 }
				}
		},
		deletepos(key) {
			for (var i = 0; this.data.length; i++) {
				if (key == i) {
					this.data.splice(i, 1);
					var	array = JSON.stringify(this.data);
					this.setCookie('data',array);
					var count=this.getCookie('count');
					this.setCookie('count', count-1);
					this.priceFunction();
					this.$forceUpdate();
					return;
				}
			}
		},
		setCookie(id, value) {
			document.cookie = id + '=' + value + ';path=/';
		},
		getCookie(name) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}
			return null;
		},
    openModal(){
      var app = this;
      $('#'+app.id).modal({
        backdrop: false,
        keyboard: false
      });
			this.$modal = true;
      $('.modal').css('display', 'block');
			var data= this.getCookie('data');
			if (data!==null){
				this.data = JSON.parse(data);
			}
			app.priceFunction();
			this.$forceUpdate();
		},
		closeModal(){
			var app = this;
			this.$modal = false;
			$('#'+app.id).modal('hide');
			$('.modal').css('display', 'none');
			app.$emit('close-modal');
		},
		getMessage(){
			axios.get(this.urls.message).then(({ data }) => (this.message = data.data));
		},
    init(){
      var app = this;
			this.getMessage();
		}
  },
  mounted: function(){
    var app = this;
    app.init();
  },
	created() {

	}

}
</script>
